import React, { useContext } from 'react';
import './ModuleDetailModal.css';
import Toggle from '../Toggle/Toggle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ModuleAdminContext } from '../../contexts/ModuleAdminContext';
import groupTypes from '../../common/groupTypes';
import logComponent from '../../common/logComponent';

export default function ModuleDetailModalAvailabilityContent({ toggleGroupTypePermissions }) {
  const moduleAdminContext = useContext(ModuleAdminContext);
  const {
    currentGroupTypePermissions,
    groupTypePermissionsLoading,
    groupTypePermissionsError,
  } = moduleAdminContext;

  if (logComponent('ModuleDetailModalAvailabilityContent')) { console.debug('ModuleDetailModalAvailabilityContent render'); }

  return (

    <div>
      <p className="Module-Detail-Modal__availability-instruction">To which types of users is this module available?</p>
      {
        !groupTypePermissionsLoading && !groupTypePermissionsError ?
          <ul className="Module-Detail-Modal__availability-list">
            {
              groupTypes.map(groupType =>
                <li
                  className="Module-Detail-Modal__availability-list-item"
                  key={groupType.groupTypeEnum}>
                  <FontAwesomeIcon
                    icon="users"
                    className="Module-Detail-Modal__availability-list-icon" />
                  <span className="Module-Detail-Modal__group-type-name">{groupType.groupTypeString + (groupType.groupTypeString === 'Family' ? ' members' : ' staff')}</span>
                  <Toggle
                    selected={currentGroupTypePermissions.includes(groupType.groupTypeEnum)}
                    toggleValue={toggleGroupTypePermissions}
                    toggleValueParam={groupType.groupTypeEnum}
                    showTextValue={true}
                    trueText="Enabled"
                    falseText="Disabled"
                  />
                </li>
              )
            }
          </ul> :
          <p className="Module-Detail-Modal__availability-status-text">
            {
              groupTypePermissionsLoading &&
              <span>Loading user type permissions...</span>
            }
            {
              groupTypePermissionsError &&
              <span>Unable to load user type permissions.</span>
            }
          </p>
      }

    </div>
  );
}

